<template>
  <div class="zee zee-component zee-table">
    <a-spin :spinning="superLoading" tip="加载中...">
      <template #icon>
        <icon-loading style="font-size: 24px;" />
      </template>
      <a-timeline v-for="(column, field) in data.data.data" :key="field">
        <a-timeline-item>{{column.name}} {{column.create_at}}</a-timeline-item>
      </a-timeline>
      <!-- <a-table
          v-if="columns && superData && superFilter && data && data.data && data.data.data"
          row-key="id"
          :columns="columns"
          :data="data.data.data"
          :bordered="{ cell: true }"
          :default-expand-all-rows="false"
          @change="bindTableChange"
          :pagination="{
            total: parseInt(data.data.count),
            current: parseInt(superFilter.page || 1),
            pageSize: parseInt(superFilter.limit || 10),
            showTotal: total => `共${total}行`,
            showPageSize: true,
            pageSizeOptions:['10','20','30','40','50','100','300','500']
          }"

      ></a-table> -->
    </a-spin>
  </div>
</template>

<script>
import { IconLoading } from '@arco-design/web-vue/es/icon'

export default {
  name: 'FTimeline',
  components: {
    IconLoading
  },
  props: {
    superLoading: Boolean,
    superData: Object,
    superColumns: Array,
    superFilter: Object
    },
    // async created() {
    //   if (this.superData) {
    //     await this.loadData()
    //   }
    // },
    computed: {
      columns() {
        const state = this.$store.state
        if (state.page) {
          const {tableColumns} = state.page
          const columns = []
          for (let k in tableColumns) {
            const column = tableColumns[k]
            if (!column.hidden || column.hidden.indexOf('list')<0) {
              columns.push(column)
            }
          }
          // console.log('columns', columns)
          return columns
        } else {
          return Array
        }
      },
      data() {
        const data = this.$store.state.page
        return this.$fan.utils.parse(data)
      }
    },
    // data() {
    //   return {
    //     data: {},
    //     def: {
    //       data: {}
    //     }
    //   }
    // },
    methods: {
      async loadData() {
        // const data = this.$fan.storage.getStorage('zee-page')
        // const data = this.$store.state.page
        // this.data = this.$fan.utils.parse(data)
        // console.log(this.data)
        // const superData = this.$fan.utils.parse(this.superData)
        // this.data.data = superData.data
      },
      bindTableChange(pagination, filters, sorter) {
        console.log(''+JSON.stringify(pagination)+''+JSON.stringify(filters)+''+JSON.stringify(sorter))
        // '@showSizeChange': e => bindChangeLimit(e),
        this.$emit('change', pagination, filters, sorter)
      },
      bindpicPreview(file) {
        this.visible = true
        this.picview = file + '?x-oss-process=style/default'
      },
      bindpicPreviewCancle() {
        this.picview = false
      },
      bindDownload(url) {
        window.open(url, '_blank')
      }
    }
  }
</script>